module.exports = __webpack_public_path__ + "static/ses-2021-strategic-report-1dfd5f42bff32949ead3e715fd82b146.pdf";